// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_PRh","cls2":"EvaluatePublicationFinderPage-cls2_AX6 EvaluatePublicationFinderPage-cls1_PRh"};